/**
 * Tenants Page - PLACEHOLDER
 * TODO: Create tenant management page (JLL Super Admin only)
 */
import React from 'react';
import { Box, Typography, Container } from '@mui/material';

const TenantsPage = () => {
  return (
    <Container maxWidth="xl" sx={{ py: 4 }}>
      <Box>
        <Typography variant="h4" gutterBottom>
          Tenant Management
        </Typography>
        <Typography variant="body1" color="text.secondary">
          JLL Super Admin only - Manage tenants, features, and configurations
        </Typography>
      </Box>
    </Container>
  );
};

export default TenantsPage;





